import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {NolimitPlugin} from "@nolimitcity/slot-launcher/bin/NolimitPlugin";
import {Logger, LogLevel} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {GameFlowController} from "@nolimitcity/slot-game/bin/flowcontrol/GameFlowController";
import {FlowState} from "@nolimitcity/slot-game/bin/flowcontrol/FlowState";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FontLoader} from "@nolimitcity/slot-launcher/bin/loader/FontLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {AssetsConfig} from "@nolimitcity/slot-game/bin/asset/AssetsConfig";
import {AssetLoader} from "@nolimitcity/slot-game/bin/asset/AssetLoader";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/asset/ResourcesGroupName";
import {KMDGameAssets} from "./KMDGameAssets";
import {KMDSound} from "./sound/KMDSound";
import {KMDBackgroundElements} from "./view/KMDBackgroundElements";
import {KMDWinPresentation} from "./gameflow/KMDWinPresentation";
import {KMDReelStartPresentation} from "./gameflow/KMDReelStartPresentation";
import {KMDReelStopPresentation} from "./gameflow/KMDReelStopPresentation";
import {KMDNormalIdlePresentation} from "./gameflow/KMDNormalIdlePresentation";
import {KMDBonusIdlePresentation} from "./gameflow/KMDBonusIdlePresentation";
import {
    IFeatureInfo,
    ISymbolValues,
    KMD_SYMBOL_ANIMATIONS,
    SPECIAL_SYMBOL_NAMES,
    WIN_CAP_MODES,
    X_HOLE_ANIMATIONS
} from "./server/IKMDData";
import {KMDModel} from "./server/KMDModel";
import {KMDReelsView} from "./reels/KMDReelsView";
import {TemplateAsset, TemplateLoader} from "@nolimitcity/slot-launcher/bin/loader/TemplateLoader";
import {KMDGameMode} from "./server/KMDGameMode";
import {KMDSpecialReelView} from "./reels/KMDSpecialReelView";
import {KMDAvalancheIdlePresentation} from "./gameflow/avalanche/KMDAvalancheIdlePresentation";
import {KMDAvalancheBetPresentation} from "./gameflow/avalanche/KMDAvalancheBetPresentation";
import {KMDAvalancheResultPresentation} from "./gameflow/avalanche/KMDAvalancheResultPresentation";
import {KMDLogo} from "./view/KMDLogo";
import {KMDMgIntro} from "./view/KMDMgIntro";
import {gsap} from "gsap";
import {KMDFSIntro} from "./view/fsTransitionScreens/KMDFSIntro";
import {KMDSFSIntro} from "./view/fsTransitionScreens/KMDSFSIntro";
import {KMDFSOutro} from "./view/fsTransitionScreens/KMDFSOutro";
import {KMDSFSOutro} from "./view/fsTransitionScreens/KMDSFSOutro";
import {KMDWinOverlays} from "./view/KMDWinOverlays";
import {KMDXWaysReveal} from "./view/KMDXWaysReveal";
import {KMDBigWin} from "./view/KMDBigWin";
import {KMDBlackBg} from "./view/KMDBlackBg";
import {BasicBitmapCountUp} from "./view/BasicBitmapCountUp";
import {KMDPossibleWays} from "./view/KMDPossibleWays";
import {KMDXHOverlayAnimations} from "./view/KMDXHOverlayAnimations";
import {KMDxBet} from "./view/KMDxBet";
import {KMDReelFrame} from "./view/KMDReelFrame";
import {KMDCar} from "./view/KMDCar";
import {KMDxBetReelFrame} from "./view/KMDxBetReelFrame";
import {KMDWinCap} from "./view/KMDWinCap";
import {KMDStickyS2} from "./view/KMDStickyS2";
import {KMDXHoleSuck} from "./reels/KMDXHoleSuck";
import {KMDStickyXH} from "./view/KMDStickyXH";
import {KMDToggle} from "./view/KMDToggle";
import {KMDMultipliersChain} from "./view/KMDMultipliersChain";
import {KMDCFSIntro} from "./view/fsTransitionScreens/KMDCFSIntro";
import {KMDCFSOutro} from "./view/fsTransitionScreens/KMDCFSOutro";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {KMDAdditionalFSAward} from "./view/KMDAdditionalFSAward";
import {KMDStickyWilds} from "./view/KMDStickyWilds";
import {KMDStickyXNudges} from "./view/KMDStickyXNudges";
import {KMDXHBlackBg} from "./view/KMDXHBlackBg";
import {KMDSymbol} from "./reels/KMDSymbol";
import {KMDMiniPayTable} from "./view/KMDMiniPayTable";
import {SimpleReelModel, SimpleReelModelSymbolData} from "../core/reel/simplereel/SimpleReelModel";
import {KMDWinAmount} from "./view/KMDWinAmount";
import {KMDNearWinAnticipation} from "./view/KMDNearWinAnticipation";
import {KMDLimitCapButton} from "./view/KMDLimitCapButton";
import {APIFeatureBetEventData} from "@nolimitcity/slot-launcher/bin/interfaces/APIBetEventData";
import {APIBetType} from "@nolimitcity/slot-launcher/bin/interfaces/APIBetType";
import {FontStyle, FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {GameModeMetaDataList} from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/BetLevelHandler";
import {Skinner} from "./Skinner";
import {SkinLogo} from "../SkinLogo";
import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";

export class KennethMustDie extends SlotGame {

    public static REELS_NUM: number = 5;
    public static MAIN_REELS_TOP: number = 165;
    public static SPECIAL_REEL_TOP: number = 615;
    public static SYMBOL_WIDTH: number = 144;
    public static SYMBOL_HEIGHT: number = 150;
    public static HEIGHT_PER_PART_X_WAYS: number = 100;
    public static SYMBOLS_NUM_PER_REEL: number[] = [2, 4, 5, 6, 2];
    public static LOW_SYMBOL_NAMES: string[] = ["L1", "L2", "L3", "L4", "L5"];
    public static SCATTER_NEAR_WIN_DELAY: number = 1;
    public static AVALANCHE_SYM_DROP_ROW: boolean[] = [false, false, false];
    public static SYMBOL_MAX_SPLIT_PARTS: number[] = [8, 5, 4];
    public static buyFeatureName: string = "";
    public static isActionSpinsActive: boolean = false;
    public static reelAreaSymbolsName: string[][] = []; // only using this in update texture after M1/M2 feature.
    public static s1CountReelStop: number = 0;
    public static mode: string; // #405
    public static useCensor: boolean;
    public static symbolsToBeCensored: string[] = ["L2", "L5"]; // XH is also censored but that is handled via spine
    public static limitCapAllowed: boolean = false;
    public static sfsFeatureBought: boolean;
    public static canPlayCollapseSoundInMainReels: boolean; // #460
    public static maxBetStandard: number = 0;
    public static maxBet10K: number = 0;
    public static liteSFSBuyCount: number = 0; // #560

    public static model: KMDModel;
    public static assetLoader: AssetLoader;
    public static gameFlowController: GameFlowController;
    public static normalIdle: KMDNormalIdlePresentation;

    public static soundPlayer: KMDSound;
    public static xHoleSuck: KMDXHoleSuck;

    public static backgroundElements: KMDBackgroundElements;
    public static reelView: KMDReelsView;
    public static specialReelView: KMDSpecialReelView;
    public static logo: KMDLogo;
    public static mgIntro: KMDMgIntro;
    public static fsIntro: KMDFSIntro;
    public static fsOutro: KMDFSOutro;
    public static cfsIntro: KMDCFSIntro;
    public static cfsOutro: KMDCFSOutro;
    public static sfsIntro: KMDSFSIntro;
    public static sfsOutro: KMDSFSOutro;
    public static winOverlays: KMDWinOverlays;
    public static xWaysReveal: KMDXWaysReveal;
    public static bigWin: KMDBigWin;
    public static blackBg: KMDBlackBg;
    public static winCapCountUp: BasicBitmapCountUp;
    public static countUp: BasicBitmapCountUp;
    public static possibleWays: KMDPossibleWays;
    public static xHoleOverlayAnimations: KMDXHOverlayAnimations;
    public static xHoleBlackBg: KMDXHBlackBg;
    public static xBet: KMDxBet;
    public static reelFrame: KMDReelFrame;
    public static car: KMDCar;
    public static xBetReelFrame: KMDxBetReelFrame;
    public static winCap: KMDWinCap;
    public static stickyS2: KMDStickyS2;
    public static stickyXH: KMDStickyXH;
    public static toggle: KMDToggle;
    public static multipliersChain: KMDMultipliersChain;
    public static additionalFSAward: KMDAdditionalFSAward;
    public static stickyWilds: KMDStickyWilds;
    public static stickyXNudges: KMDStickyXNudges;
    public static miniPayTable: KMDMiniPayTable;
    public static winAmount: KMDWinAmount;
    public static nearWinAnticipation: KMDNearWinAnticipation;
    public static limitCapButton: KMDLimitCapButton;

    private _defaultSymbolValues: ISymbolValues = {
        "M1": {"3": 0.5, "4": 1.25, "5": 2.5},
        "M2": {"3": 0.25, "4": 0.4, "5": 1},
        "M3": {"3": 0.2, "4": 0.3, "5": 0.75},
        "M4": {"3": 0.2, "4": 0.3, "5": 0.6},
        "M5": {"3": 0.2, "4": 0.25, "5": 0.5},
        "L1": {"3": 0.15, "4": 0.2, "5": 0.4},
        "L2": {"3": 0.15, "4": 0.2, "5": 0.4},
        "L3": {"3": 0.15, "4": 0.2, "5": 0.4},
        "L4": {"3": 0.1, "4": 0.15, "5": 0.3},
        "L5": {"3": 0.1, "4": 0.15, "5": 0.3}
    };
    private skinner:Skinner;
    private static skinLogo:SkinLogo;

    constructor() {
        super();
        const validSkinIds:string[] = [
            "ug",
            "ozzo",
            "test"
        ]
        this.skinner = new Skinner(validSkinIds);
    }

    /**
     * This is a new approach to this problem, with the focus being to really tie to the kinds of animations together to make a "gsap safe"
     * spine animation that actually follows the playHead of any parent timeline and supports other gsap features, such as reverse(), seek() etc.
     * Instead of just starting and stopping animations at different times.
     *
     * Caveat:
     * Does only set a new spine animation at beginning and end of the timeline.
     * So if you try to play the timeline from, say halfway into the animation, and this is not the already set spine animation.
     * It will play the current set spine animation. So playing animations not completely from the start or end (reverse(0)), will probably
     * cause you lots of headache.
     *
     * Easing do work. But be a bit cautious with easing that have overshoot. E.g. Back, or Elastic etc.
     * Because we are only animating the play head on the spine animation, there is no "overshoot". You cant play the animation longer than it is.
     *
     * !!! YOU NEED TO SET "autoUpdate = false" on your spine object.
     *
     *
     * @param spine PIXI.spineSpine object
     * @param trackIndex
     * @param animationName
     * @param loop
     * @param animationAlpha
     * @param mixDuration
     * @param resetOnComplete
     * @private
     */
    public static createTimelineForAnimation(spine: PIXI.spine.Spine, trackIndex: number, animationName: string, loop: boolean, animationAlpha: number = 1, mixDuration: number = 0, resetOnComplete: boolean = true): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline({
            repeat: loop ? -1 : 0
        });

        if (!spine.spineData || !spine.state) {
            return tl;
        }

        const animation: PIXI.spine.core.Animation = spine.spineData.findAnimation(animationName);
        if (!animation) {
            console.error(`No animation named ${animationName}`);

            return tl;
        }

        spine.autoUpdate = false;

        const setAnimation: () => void = () => {
            if (spine.state) {
                const trackEntry: PIXI.spine.core.TrackEntry = spine.state.setAnimationWith(trackIndex, animation, false);
                trackEntry.alpha = animationAlpha;
                trackEntry.mixDuration = mixDuration;
            }
        };

        const target = {
            playHead: 0,
            spine: spine,
            prevTime: 0
        };

        const updateFunc: () => void = () => {
            if (spine && target && spine.state) {
                const now = target.playHead;
                spine.update(now - target.prevTime);
                target.prevTime = now;
            }
        };

        tl.add(() => {
            target.prevTime = 0;
            setAnimation();
        });
        tl.fromTo(target, {playHead: 0}, {
            duration: animation.duration,
            playHead: animation.duration,
            onUpdate: updateFunc,
            ease: "none"
        });
        if (resetOnComplete) {
            tl.add(() => {
                target.prevTime = 0;
                setAnimation();
            });
        }
        tl.to(target, {duration: 0.0001}); //Needed so gsap does not skip "setAnimation" during reverse play.
        tl.add(() => {
            target.playHead = animation.duration;
            updateFunc();
        });

        return tl;
    }

    public static updateWaysOnReelStopActions(multipliers: number[][]): void {
        // #326
        KennethMustDie.SYMBOLS_NUM_PER_REEL[0] = (Math.max(multipliers[0][1], 1) + Math.max(multipliers[0][2], 1));
        KennethMustDie.SYMBOLS_NUM_PER_REEL[4] = (Math.max(multipliers[4][1], 1) + Math.max(multipliers[4][2], 1));
        for (let reelId: number = 1; reelId < multipliers.length - 1; reelId++) {
            KennethMustDie.SYMBOLS_NUM_PER_REEL[reelId] = 0;
            for (let symId: number = 0; symId < multipliers[reelId].length; symId++) {
                KennethMustDie.SYMBOLS_NUM_PER_REEL[reelId] += Math.max(multipliers[reelId][symId], 1);
            }
        }

        this.possibleWays.updateWays();
    }

    public static tryAnticipation(reelId: number): void {
        const nextId: number = (reelId + 1);

        if (KennethMustDie.model.nearWinReels[nextId]) {
            KennethMustDie.nearWinAnticipation.playAnticipation(nextId, (nextId === 4 ? 1.5 : 1), ((nextId > 2 && KennethMustDie.model.xHPos === 1) ? 2 : (nextId === 4 ? 1 : 0)));
        }
    }

    public static stopScattersAnticipation(): void {
        // #485
        if (KennethMustDie.s1CountReelStop < 3) {
            for (let i: number = 0; i < KennethMustDie.model.s1Positions.length; i++) {
                if (KennethMustDie.model.s1Positions[i] > -1) {
                    KennethMustDie.nearWinAnticipation.stopAnticipationFire(i);
                }
            }
        }

        // #485
        if (KennethMustDie.model.s2Feature.originReelId === -1) {
            KennethMustDie.nearWinAnticipation.stopXHAnticipationFire();
        }

        KennethMustDie.model.setIsSFSTriggered();
        KennethMustDie.nearWinAnticipation.stopAllAnticipations(-1);

        KennethMustDie.soundPlayer.tryStopScatterAnticipationSound();
    }

    public static returnToMainGame(duration: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        tl.add([
            KennethMustDie.blackBg.hide(duration),
            () => {
                KennethMustDie.xBet.toggleVisibility(true);
                KennethMustDie.limitCapButton.toggleVisibility(true);

                KennethMustDie.soundPlayer.switchMusic(KennethMustDie.model.gameData.nextMode);

                this.hideBonusGameStickyItems();

                this.buyFeatureName = "";

                this.mode = KMDGameMode.NORMAL;

                // #499
                KennethMustDie.setFakeReelSet();
            }
        ]);

        return tl;
    }

    public static hideBonusGameStickyItems(): void {
        KennethMustDie.stickyS2.hideLock();
        KennethMustDie.stickyXH.hideLock();
        KennethMustDie.stickyWilds.hideAllStickyWilds();
        KennethMustDie.stickyXNudges.hideAllStickyXNudges();
    }

    public static isWinBelowStake(): boolean {
        return this.apiPlugin.gameClientConfiguration.belowStakeWinRestriction && (this.model.data.accumulatedRoundWin <= this.getBuyFeaturePrice());
    }

    public static getBuyFeaturePrice(): number {
        const betLevel: string = KennethMustDie.apiPlugin.freeBets.hasFreeBets() ? KennethMustDie.apiPlugin.freeBets.getBet() : KennethMustDie.apiPlugin.betLevel.getLevel();
        let price: number = KennethMustDie.model.gameData?.playedBetValue || parseFloat(betLevel);
        if (this.buyFeatureName) {
            for (let index: number = 0; index < KennethMustDie.model.initData.featureBuyTimesBetValue.length; index++) {
                if (KennethMustDie.model.initData.featureBuyTimesBetValue[index].name === this.buyFeatureName) {
                    price = (((price * 1000) * (KennethMustDie.model.initData.featureBuyTimesBetValue[index].price * 1000)) / (1000000)); // #571
                    break;
                }
            }
        }
        return price;
    }

    public static setKeypadWin(useTotalWin: boolean): void {
        this.keypadPlugin.setWin(this.model.data.accumulatedRoundWin, useTotalWin, this.isWinBelowStake());
    }

    public static isSingleWinBelowStake(): boolean {
        return this.apiPlugin.gameClientConfiguration.belowStakeWinRestriction && (this.model.gameData.totalAvalancheRoundWinnings <= this.getCost());
    }

    // #499
    public static setFakeReelSet(): void {
        const reelSetsAsPerMode: string[][] = this.getReelSetsAsPerMode();

        this.reelView.reelModels.forEach((reel: SimpleReelModel, idx: number) => {
            reel.setReelSet(reelSetsAsPerMode[idx]);
        });
    }

    private static getCost(): number {
        const betLevel: string = KennethMustDie.apiPlugin.freeBets.hasFreeBets() ? KennethMustDie.apiPlugin.freeBets.getBet() : KennethMustDie.apiPlugin.betLevel.getLevel();
        let price: number = KennethMustDie.model.gameData?.playedBetValue || parseFloat(betLevel);
        if (this.buyFeatureName.includes("_BET") || this.buyFeatureName.includes("X_HOLE")) {
            price *= (KennethMustDie.apiPlugin.bonusFeatures.getFeatureDataByName(this.buyFeatureName) ? KennethMustDie.apiPlugin.bonusFeatures.getFeatureDataByName(this.buyFeatureName)!.price : price);
        }

        return price;
    }

    private static getSymbolString(key: string, data: { [numSymbols: number]: number }): string {
        return `
            <div class="symbol">
            <img src="{{gamePath}}screens/images/symbols/${key}.png">
            <div class="payout-group">
                <div class="payout">
                    <span class="number">5</span>
                    <span class="multiplier" data-multiplier="${data[5]}">${data[5]}</span>
                </div>
                <div class="payout">
                    <span class="number">4</span>
                    <span class="multiplier" data-multiplier="${data[4]}">${data[4]}</span>
                </div>
                <div class="payout">
                    <span class="number">3</span>
                    <span class="multiplier" data-multiplier="${data[3]}">${data[3]}</span>
                </div>
            </div>
            </div>
        `;
    }

    private static getReelSetsAsPerMode(): string[][] {
        const nextMode: string = KennethMustDie.model.data.nextMode;

        if (nextMode === KMDGameMode.NORMAL || nextMode === KMDGameMode.NORMAL_AVALANCHE) {
            return [
                ["M1", "L4", "L1", "M4", "L4", "L3", "L1", "SM1", "M5", "L2", "L1", "M4", "M3", "L1", "M5", "L5", "L2", "L4", "L2", "M5", "L1", "M2", "L4", "M3", "L5", "L4", "M1", "L1", "L2", "L4", "L3", "L5", "M5", "L1", "L5", "SM2", "L3", "M4", "L1", "L2", "L5", "M4"],
                ["M1", "L4", "L5", "X_NUDGE_WILD", "L4", "L3", "L5", "M4", "L2", "L5", "W", "M4", "M3", "L1", "M5", "L5", "M1", "L5", "L2", "L4", "L2", "L1", "M2", "SM1", "M3", "M2", "L4", "M3", "M4", "M3", "L5", "M1", "L1", "L2", "L4", "L3", "L5", "M5", "L1", "SM2", "L5", "M2", "L3", "L4", "M2", "S", "L3", "M4", "L1", "L2", "L5", "W"],
                ["M1", "L4", "L1", "X_NUDGE_WILD", "M2", "L4", "M3", "L3", "L1", "XH", "M1", "M4", "L2", "M4", "M3", "L1", "M5", "SM2", "L5", "M1", "M2", "L4", "M3", "L3", "M5", "M4", "L2", "M5", "L1", "L5", "M2", "SM1", "M3", "L4", "M1", "L3", "L1", "L2", "S", "M1", "L5", "M4", "L5", "L2", "W"],
                ["M1", "L4", "L1", "X_NUDGE_WILD", "M4", "L4", "L3", "L1", "M5", "L2", "L1", "M4", "M3", "L1", "M5", "L5", "L2", "L4", "L2", "M5", "L1", "M2", "L4", "M3", "SM2", "L5", "L4", "L1", "L2", "L4", "L3", "L5", "M5", "M1", "L4", "L1", "M4", "L4", "L3", "L1", "M5", "L2", "L1", "M4", "M3", "L1", "M5", "L5", "L2", "L4", "L2", "M5", "L1", "M2", "L4", "M3", "L5", "L4", "L1", "L2", "L4", "L3", "L5", "M5", "M1", "L4", "L1", "M4", "L4", "L3", "L1", "M5", "L2", "L1", "M4", "M3", "L1", "M5", "L5", "L2", "W", "L4", "L2", "M5", "L1", "M2", "L4", "M3", "L5", "L4", "M1", "L1", "L2", "L4", "L3", "L5", "M5", "L1", "L5", "L3", "M4", "L1", "L2", "L5", "M4", "L2", "M1", "L4", "L1", "L4", "S"],
                ["M3", "L3", "L1", "M4", "L4", "SM1", "L5", "M4", "M5", "L2", "M5", "L3", "M4", "M5", "L1", "L3", "L4", "SM2", "M5", "L3", "L5", "M1", "L1", "M3", "L1", "L3", "M5", "L4", "M4", "L1", "L5", "M5", "L1", "L4", "L2", "S2", "L3", "M4", "M5", "L3", "L2", "M2", "L1", "L5", "L3"]
            ];
        } else if (nextMode === KMDGameMode.FREESPIN || nextMode === KMDGameMode.FREESPIN_AVALANCHE) {
            return [
                ["M3", "L4", "M5", "L1", "M2", "L3", "M1", "L5", "SM1", "M4", "L2", "M5", "L5", "M4", "L2", "M5", "L1", "L5", "M2", "M3", "L4", "M1", "L3", "L1", "M3", "SM2", "L2", "L5", "L1", "M1", "L3", "M2", "L4", "M4", "M3", "L2", "M5", "L5", "L1"],
                ["M5", "L4", "X_NUDGE_WILD", "M3", "L2", "W", "M4", "M2", "L1", "M3", "L4", "M5", "L1", "M2", "L3", "SM1", "M1", "L5", "M4", "L2", "M3", "L2", "M5", "L5", "L1", "M3", "L2", "L5", "L1", "M1", "L3", "M2", "SM2", "L4", "M4", "M3", "L2", "M5", "L5", "L1"],
                ["L2", "M5", "X_NUDGE_WILD", "L4", "L1", "M2", "L1", "M4", "L5", "W", "M3", "M3", "L4", "M5", "SM1", "L1", "M2", "L3", "M1", "L5", "M4", "L2", "L5", "L1", "L3", "XH", "M1", "L1", "M4", "L3", "L1", "M2", "L2", "L4", "M1", "L2", "SM2", "M4", "L1", "M3"],
                ["M5", "M1", "X_NUDGE_WILD", "M3", "L4", "SM1", "M5", "L1", "M2", "L3", "M1", "L5", "M4", "L2", "L4", "M2", "M4", "L2", "M5", "L1", "L5", "M2", "M3", "L4", "M1", "L3", "L1", "SM2", "M4", "L5", "M3", "L2", "L1", "M3", "L2", "M5", "L5", "L1", "M2", "L3"],
                ["L4", "M5", "L3", "M4", "L5", "M2", "M2", "L1", "M4", "L5", "M3", "L2", "L1", "M3", "L4", "M5", "L1", "M2", "L3", "M1", "L5", "M4", "L2", "M3", "L2", "M5", "L5", "L1", "L3", "M1", "S2"]
            ];
        } else if (nextMode === KMDGameMode.FREESPIN_COOL || nextMode === KMDGameMode.FREESPIN_COOL_AVALANCHE) {
            return [
                ["L5", "M3", "L2", "L1", "M3", "L2", "SM1", "M5", "M3", "L4", "M5", "L1", "M2", "L3", "M1", "L5", "M4", "L2", "L5", "L1", "M3", "L2", "L5", "L1", "M1", "L3", "SM2", "M2", "L4", "M4", "M3", "L2", "M5", "L5", "L1"],
                ["M5", "L4", "M3", "L2", "M4", "M2", "SM1", "L1", "M4", "M3", "L4", "M5", "L1", "X_NUDGE_WILD", "M2", "L3", "M1", "L5", "M4", "L2", "L5", "W", "M3", "L2", "L1", "M3", "L2", "SM2", "M5", "L5", "L1", "M3", "L2", "L5", "L1", "M1", "L3", "M2", "L4", "M4", "M3", "L2", "M5", "L5", "L1"],
                ["L2", "M5", "L4", "L1", "M2", "L1", "SM1", "M3", "L4", "M5", "L1", "M2", "L3", "X_NUDGE_WILD", "M1", "L5", "M4", "L2", "W", "M4", "L5", "M3", "L2", "L1", "M3", "L2", "M5", "SM2", "L5", "L1", "L3", "M1", "L1", "M4", "L3", "L1", "M2", "L2", "L4", "M1", "L2", "M4", "L1", "M3", "XH"],
                ["M5", "M1", "L4", "M2", "L3", "M1", "SM1", "L4", "M3", "L4", "M5", "L1", "M2", "X_NUDGE_WILD", "L3", "M1", "L5", "M4", "W", "L2", "M2", "L1", "M4", "L5", "M3", "L2", "L1", "SM2", "M3", "L2", "M5", "L5", "L1", "M2", "L3"],
                ["L4", "M5", "L3", "M4", "L5", "M2", "M2", "L1", "M3", "L4", "M5", "L1", "M2", "L3", "M1", "L5", "M4", "L2", "M4", "L5", "M3", "L2", "L1", "M3", "L2", "M5", "L5", "L1", "L3", "M1"]
            ];
        } else {
            return [
                ["L5", "M3", "L2", "L1", "M3", "L2", "M5", "SM1", "M3", "L4", "M5", "L1", "M2", "L3", "M1", "L5", "W", "M4", "L2", "L5", "L1", "M3", "L2", "L5", "L1", "SM2", "M1", "L3", "M2", "L4", "M4", "M3", "L2", "M5", "L5", "L1"],
                ["M5", "L4", "M3", "X_NUDGE_WILD", "L2", "M4", "M2", "L1", "SM1", "M4", "L5", "M3", "L2", "W", "L1", "M3", "L2", "M5", "M2", "L4", "M3", "L3", "M5", "L1", "L2", "M1", "SM2", "L5", "M4", "L5", "L1", "M3", "L2", "L5", "L1", "M1", "L3", "M2", "L4", "M4", "M3", "L2", "M5", "L5", "L1"],
                ["L2", "M5", "L4", "X_NUDGE_WILD", "L1", "M2", "L1", "M4", "SM1", "L5", "M2", "L4", "M3", "W", "L3", "M5", "L1", "L2", "M1", "L5", "M4", "M3", "L2", "L1", "M3", "L2", "SM2", "M5", "L5", "L1", "L3", "M1", "L1", "M4", "L3", "L1", "M2", "L2", "L4", "M1", "L2", "M4", "L1", "M3"],
                ["M5", "M1", "L4", "X_NUDGE_WILD", "M2", "L3", "M1", "L4", "SM1", "M2", "M2", "L4", "M3", "L3", "M5", "L1", "L2", "M1", "L5", "W", "M4", "L1", "M4", "L5", "M3", "L2", "SM2", "L1", "M3", "L2", "M5", "L5", "L1", "M2", "L3"],
                ["L4", "M5", "L3", "M4", "L5", "M2", "M2", "L1", "M4", "M2", "L4", "M3", "L3", "M5", "L1", "L2", "M1", "L5", "M4", "L5", "M3", "L2", "L1", "M3", "L2", "M5", "L5", "L1", "L3", "M1"]
            ];
        }
    }

    public getNoWinGameData(): any {
        return {
            "reels": [
                [
                    "L1",
                    "L5",
                    "L1",
                    "M2"
                ],
                [
                    "L2",
                    "M3",
                    "L2",
                    "L4"
                ],
                [
                    "L4",
                    "M2",
                    "L3",
                    "M1"
                ],
                [
                    "L5",
                    "M3",
                    "M2",
                    "L5"
                ],
                [
                    "L3",
                    "L3",
                    "L5",
                    "L2"
                ]
            ],
            "evaluatedArea": [
                [
                    "X",
                    "L5",
                    "L1",
                    "X"
                ],
                [
                    "L2",
                    "M3",
                    "L2",
                    "L4"
                ],
                [
                    "L4",
                    "M2",
                    "L3",
                    "M1"
                ],
                [
                    "L5",
                    "M3",
                    "M2",
                    "L5"
                ],
                [
                    "X",
                    "L3",
                    "L5",
                    "X"
                ]
            ],
            "betWayWins": [],
            "thisAvalancheWinnings": 0,
            "totalAvalancheRoundWinnings": 0,
            "accumulatedRoundWin": 0,
            "playedBetValue": 1,
            "mode": "NORMAL",
            "nextMode": "NORMAL",
            "numberOfFreespinsPlayed": 0,
            "freespinsLeft": 0,
            "wasFeatureBuy": false,
            "specialReels": [
                "L4",
                "M1",
                "L5"
            ],
            "brokeTheBank": false,
            "testOutcome": "TestOutcome{hasOverrideReels=true, hasOverrideFlag=false, overrideFlag='X', overrideReels='[L1, L5, L1, null, null][L2, M3, L2, L4, null][L4, M2, L3, M1, null][L5, M3, M2, L5, null][null, L3, L5, null, null]'}",
            "multiplier": [
                [
                    0,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    2
                ],
                [
                    0,
                    0,
                    0,
                    3
                ],
                [
                    0,
                    0,
                    0,
                    4
                ],
                [
                    0,
                    0,
                    0,
                    0
                ]
            ],
            "s1TransformList": [],
            "mysterySymbolSize": -1,
            "totalBetWaySpinWinnings": 0,
            "totalSpecialBetWaySpinWinnings": 0
        };
    }

    public getGameModeMetaData(): GameModeMetaDataList {
        return {
            "CAP_MODE_10000": {
                buttonLabel: "10000x",
            },
            "CAP_MODE_STANDARD": {
                buttonLabel: "69000x",
                standard: true
            }
        };
    }

    public init(): Promise<NolimitPlugin> {
        return super.init().then((value: NolimitPlugin) => {
            KennethMustDie.model = new KMDModel(SlotGame.apiPlugin, true);
            KennethMustDie.gameFlowController = new GameFlowController(SlotGame.apiPlugin, KennethMustDie.model);
            KennethMustDie.gameFlowController.flowStateLogger.level = LogLevel.DEV;

            KennethMustDie.apiPlugin.events.once(APIEvent.FEATURE_BET_LEVELS, (data: any) => {
                if (data[WIN_CAP_MODES.CAP_MODE_STANDARD] && data[WIN_CAP_MODES.CAP_MODE_STANDARD]["BOOSTED_BET"]) {
                    KennethMustDie.maxBetStandard = parseFloat(data[WIN_CAP_MODES.CAP_MODE_STANDARD]["BOOSTED_BET"][data[WIN_CAP_MODES.CAP_MODE_STANDARD]["BOOSTED_BET"].length - 1]);
                }

                if (data[WIN_CAP_MODES.CAP_MODE_10000] && data[WIN_CAP_MODES.CAP_MODE_10000]["BOOSTED_BET"]) {
                    KennethMustDie.maxBet10K = parseFloat(data[WIN_CAP_MODES.CAP_MODE_10000]["BOOSTED_BET"][data[WIN_CAP_MODES.CAP_MODE_10000]["BOOSTED_BET"].length - 1]);
                }
            });

            const idleNormal: KMDNormalIdlePresentation = new KMDNormalIdlePresentation(),
                reelStart: KMDReelStartPresentation = new KMDReelStartPresentation(),
                reelStop: KMDReelStopPresentation = new KMDReelStopPresentation(),
                winPres: KMDWinPresentation = new KMDWinPresentation(),
                bonusIdle: KMDBonusIdlePresentation = new KMDBonusIdlePresentation(),
                avalancheIdle: KMDAvalancheIdlePresentation = new KMDAvalancheIdlePresentation(),
                avalancheBet: KMDAvalancheBetPresentation = new KMDAvalancheBetPresentation(),
                avalancheResult: KMDAvalancheResultPresentation = new KMDAvalancheResultPresentation();

            KennethMustDie.gameFlowController.addGameModeFlowStatePresentationMap(KMDGameMode.NORMAL, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, idleNormal],
                [FlowState.BET, reelStart],
                [FlowState.RESULT, reelStop],
                [FlowState.WIN, winPres]
            ]));
            KennethMustDie.gameFlowController.addGameModeFlowStatePresentationMap(KMDGameMode.NORMAL_AVALANCHE, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, avalancheIdle],
                [FlowState.BET, avalancheBet],
                [FlowState.RESULT, avalancheResult],
                [FlowState.WIN, winPres]
            ]));

            KennethMustDie.gameFlowController.addGameModeFlowStatePresentationMap(KMDGameMode.FREESPIN, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, bonusIdle],
                [FlowState.BET, reelStart],
                [FlowState.RESULT, reelStop],
                [FlowState.WIN, winPres]
            ]));
            KennethMustDie.gameFlowController.addGameModeFlowStatePresentationMap(KMDGameMode.FREESPIN_AVALANCHE, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, avalancheIdle],
                [FlowState.BET, avalancheBet],
                [FlowState.RESULT, avalancheResult],
                [FlowState.WIN, winPres]
            ]));

            KennethMustDie.gameFlowController.addGameModeFlowStatePresentationMap(KMDGameMode.FREESPIN_COOL, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, bonusIdle],
                [FlowState.BET, reelStart],
                [FlowState.RESULT, reelStop],
                [FlowState.WIN, winPres]
            ]));
            KennethMustDie.gameFlowController.addGameModeFlowStatePresentationMap(KMDGameMode.FREESPIN_COOL_AVALANCHE, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, avalancheIdle],
                [FlowState.BET, avalancheBet],
                [FlowState.RESULT, avalancheResult],
                [FlowState.WIN, winPres]
            ]));

            KennethMustDie.gameFlowController.addGameModeFlowStatePresentationMap(KMDGameMode.FREESPIN_SUPER, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, bonusIdle],
                [FlowState.BET, reelStart],
                [FlowState.RESULT, reelStop],
                [FlowState.WIN, winPres]
            ]));
            KennethMustDie.gameFlowController.addGameModeFlowStatePresentationMap(KMDGameMode.FREESPIN_SUPER_AVALANCHE, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, avalancheIdle],
                [FlowState.BET, avalancheBet],
                [FlowState.RESULT, avalancheResult],
                [FlowState.WIN, winPres]
            ]));

            // #345
            KennethMustDie.normalIdle = idleNormal;
            KennethMustDie.apiPlugin.events.on(APIEvent.ACTION_SPINS_IS_ACTIVE, (data: any) => {
                if (data) {
                    idleNormal.stop();
                } else {
                    KennethMustDie.reelView.reelModels.forEach((reel: SimpleReelModel) => {
                        reel.setInteractiveSymbols(true);
                    });
                    KennethMustDie.specialReelView.reel.setInteractiveSymbols(true);
                }
                KennethMustDie.isActionSpinsActive = !!data; // sometimes data can be undefined
            });

            KennethMustDie.apiPlugin.events.on(APIEvent.BET, (data: APIFeatureBetEventData) => this.onBet(data));

            // #476
            KennethMustDie.limitCapAllowed = KennethMustDie.apiPlugin.betLevel.hasCapWinLimitToggle();
            KennethMustDie.apiPlugin.events.on(APIEvent.BET_GAME_MODE_CHANGED, () => this.onBetGameModeChanged());

            // #477
            if (KennethMustDie.apiPlugin.gameClientConfiguration.isSet) {
                KennethMustDie.useCensor = (KennethMustDie.apiPlugin.gameClientConfiguration.useCensoredGfx || KennethMustDie.apiPlugin.gameClientConfiguration.useCensoredGfxUS);
            } else {
                KennethMustDie.apiPlugin.events.once(APIEvent.GAME_CLIENT_CONFIGURATION_APPLIED, () => {
                    KennethMustDie.useCensor = (KennethMustDie.apiPlugin.gameClientConfiguration.useCensoredGfx || KennethMustDie.apiPlugin.gameClientConfiguration.useCensoredGfxUS);
                });
            }

            return value;
        });
    }

    public getReady(): Promise<NolimitPlugin> {
        //Show intro and load game assets
        return super.getReady().then((value: NolimitPlugin) => {
            const fontLoader = new FontLoader(NolimitApplication.resourcePath);
            fontLoader.add(OpenSans.ITALIC_600);
            fontLoader.add(OpenSans.NORMAL_300);
            fontLoader.add(OpenSans.NORMAL_400);
            fontLoader.add(OpenSans.NORMAL_700);

            fontLoader.add({
                family: "entsans",
                weight: FontWeight.BOLD,
                style: FontStyle.NORMAL,
                url: "/resources/fonts/entsans.ttf"
            });

            KennethMustDie.soundPlayer = new KMDSound();

            AssetsConfig.addToAssetsConfig(KMDGameAssets.RESOURCES_GROUPS);
            KennethMustDie.assetLoader = new AssetLoader(KennethMustDie.apiPlugin, NolimitApplication.resourcePath + "/resources/");

            const imgLoader = new ImgLoader(NolimitApplication.resourcePath);
            imgLoader.add("skinLogo", "resources/images/skinLogo.png");

            const promises = Promise.all([fontLoader.load(),imgLoader.load(), KennethMustDie.assetLoader.load(ResourcesGroupName.MAIN)]);

            return promises.then(() => {
                this.createViewsAndComponents();


                if (this.skinner.skinId != undefined) {
                    //Source folder for skin assets e.g "resources/images/skinName";
                    const assetPath:string = "resources/images/";
                    const replaceMap:Map<string, string> = new Map();

                    //custom
                    replaceMap.set("skinLogo", "skinLogo.png");

                    //Game
                    replaceMap.set("S/S_Assets/S1_Face", "S1_Face.png");
                    replaceMap.set("S/object/MG/0/x1", "x1.png");
                    replaceMap.set("S/object/MG/1/Half_x1", "Half_x1.png");

                    //Intro
                    replaceMap.set("logo", "introLogo.png");
                    replaceMap.set("fsCfs", "Intro_fs.png");
                    replaceMap.set("sfs", "Intro_sfs.png");
                    replaceMap.set("s1AndS2Feature", "s2_change_feature.png");

                    //AS
                    replaceMap.set("AS_GAME_LOGO", "AS_GAME_LOGO.png");

                    //Bonus
                    replaceMap.set("COOL_FREESPIN", "COOL_FREESPIN.png");
                    replaceMap.set("COOL_XHOLE_FREESPIN", "COOL_XHOLE_FREESPIN.png");
                    replaceMap.set("FREESPIN", "FREESPIN.png");
                    replaceMap.set("LITE_SUPER_FREESPIN", "LITE_SUPER_FREESPIN.png");
                    replaceMap.set("LUCKY_DRAW_FREESPIN", "LUCKY_DRAW_FREESPIN.png");
                    replaceMap.set("SUPER_FREESPIN", "SUPER_FREESPIN.png");

                    this.skinner.loadSkin(assetPath, replaceMap).then((value)=>{
                        return value;
                    });
                }

                return value;
            });
        });
    }

    public getReadyToStart(): Promise<NolimitPlugin> {
        //Game assets loaded, waiting for user to start game.
        return super.getReadyToStart().then((value: NolimitPlugin) => {
            return value;
        });
    }

    public start(): Promise<NolimitPlugin> {
        //User has pressed continue and the game starts.
        return super.start().then((value: NolimitPlugin) => {
            KennethMustDie.gameFlowController.start();
            KennethMustDie.soundPlayer.switchMusic(KennethMustDie.model.data.nextMode);

            // #499
            KennethMustDie.setFakeReelSet();

            KennethMustDie.logo.play();

            if (!KennethMustDie.apiPlugin.isReplay && !KennethMustDie.model.isRestore) {
                KennethMustDie.mgIntro.play();

                // #331
                KennethMustDie.reelView.reelModels.forEach((reel: SimpleReelModel) => {
                    reel.setInteractiveSymbols(true);
                });
                KennethMustDie.specialReelView.reel.setInteractiveSymbols(true);
            }

            KennethMustDie.backgroundElements.setMode(KennethMustDie.model.data.nextMode);

            return value;
        });
    }

    public getPaytable(): Promise<string> {
        const templateLoader: TemplateLoader = new TemplateLoader(KennethMustDie.apiPlugin.resources.getStaticRoot());

        templateLoader.add({
            name: "Paytable",
            url: "nolimit/screens/paytable.mustache"
        });

        let symbolDataValueData: ISymbolValues = this._defaultSymbolValues;
        if (KennethMustDie.model.initData.symbolValues) {
            symbolDataValueData = KennethMustDie.model.initData.symbolValues;
            Logger.logDev("Using symbolValues from INIT data");
        } else {
            Logger.logDev("Using default symbolValues");
        }


        const data = {
            imagePath:"screens/images/",
            bonusPath:"bonus/",
        };

        if (this.skinner.skinId != undefined){
            data.imagePath = `../resources/images/${this.skinner.skinId}/`;
            data.bonusPath = `../resources/images/${this.skinner.skinId}/`;

        }

        return templateLoader.load().then((assets: TemplateAsset[]) => {
            for (let asset of assets) {
                if (asset.name === "Paytable" && asset.loadedData) {

                    asset.loadedData = asset.loadedData.replace(/{{imagePath}}/g, data.imagePath);
                    asset.loadedData = asset.loadedData.replace(/{{bonusPath}}/g, data.bonusPath);

                    for (let key in symbolDataValueData) {
                        // #477
                        let nameKey: string = key;
                        if (KennethMustDie.symbolsToBeCensored.includes(nameKey) && KennethMustDie.useCensor) {
                            nameKey += "_blur";
                        }
                        asset.loadedData = asset.loadedData.replace(`{{${key}}}`, KennethMustDie.getSymbolString(nameKey, symbolDataValueData[key]))
                    }
                    return asset.loadedData;
                }
            }
            throw new Error("KennethMustDie could not load Paytable");
        });
    }

    private onBet(data: APIFeatureBetEventData): void {
        // #487
        KennethMustDie.sfsFeatureBought = (data.type === APIBetType.FEATURE_BET && (data.featureName === "SUPER_FREESPIN" || data.featureName === "LITE_SUPER_FREESPIN"));

        KennethMustDie.xBet.onBet(data);
        KennethMustDie.limitCapButton.doEnableAction(false);
    }

    private onBetGameModeChanged(): void {
        const activeWinCapMode: string = KennethMustDie.apiPlugin.betLevel.getSelectedBetLevelModeName();

        if (KennethMustDie.limitCapButton) {
            if (activeWinCapMode === WIN_CAP_MODES.CAP_MODE_STANDARD) {
                KennethMustDie.limitCapButton.turnOn();
            } else {
                KennethMustDie.limitCapButton.turnOff();
            }
        }
    }

    private createViewsAndComponents(): void {
        //Non views
        KennethMustDie.xHoleSuck = new KMDXHoleSuck();

        //Static views
        KennethMustDie.backgroundElements = new KMDBackgroundElements();
        KennethMustDie.reelView = new KMDReelsView();
        KennethMustDie.specialReelView = new KMDSpecialReelView();
        KennethMustDie.logo = new KMDLogo();
        KennethMustDie.mgIntro = new KMDMgIntro();
        KennethMustDie.fsIntro = new KMDFSIntro();
        KennethMustDie.fsOutro = new KMDFSOutro();
        KennethMustDie.cfsIntro = new KMDCFSIntro();
        KennethMustDie.cfsOutro = new KMDCFSOutro();
        KennethMustDie.sfsIntro = new KMDSFSIntro();
        KennethMustDie.sfsOutro = new KMDSFSOutro();
        KennethMustDie.winOverlays = new KMDWinOverlays();
        KennethMustDie.xWaysReveal = new KMDXWaysReveal();
        KennethMustDie.bigWin = new KMDBigWin();
        KennethMustDie.blackBg = new KMDBlackBg();
        KennethMustDie.possibleWays = new KMDPossibleWays();
        KennethMustDie.xHoleOverlayAnimations = new KMDXHOverlayAnimations();
        KennethMustDie.xHoleBlackBg = new KMDXHBlackBg();
        KennethMustDie.reelFrame = new KMDReelFrame();
        if (KennethMustDie.apiPlugin.gameClientConfiguration.boostedBetAllowed) {
            KennethMustDie.xBetReelFrame = new KMDxBetReelFrame();
        }
        KennethMustDie.xBet = new KMDxBet();
        KennethMustDie.car = new KMDCar();
        KennethMustDie.winCap = new KMDWinCap();
        KennethMustDie.stickyS2 = new KMDStickyS2();
        KennethMustDie.stickyXH = new KMDStickyXH();
        KennethMustDie.toggle = new KMDToggle();
        KennethMustDie.multipliersChain = new KMDMultipliersChain();
        KennethMustDie.additionalFSAward = new KMDAdditionalFSAward();
        KennethMustDie.stickyWilds = new KMDStickyWilds();
        KennethMustDie.stickyXNudges = new KMDStickyXNudges();
        KennethMustDie.miniPayTable = new KMDMiniPayTable(KennethMustDie.model.initData.symbolValues);
        KennethMustDie.winAmount = new KMDWinAmount();
        KennethMustDie.nearWinAnticipation = new KMDNearWinAnticipation();
        KennethMustDie.limitCapButton = new KMDLimitCapButton();

        KennethMustDie.winCapCountUp = new BasicBitmapCountUp({
            fontName: KMDGameAssets.BITMAP_FONT_WIN_CAP,
            fontSize: 40,
            tint: 0xffffff
        }, 720);
        KennethMustDie.countUp = new BasicBitmapCountUp({
            fontName: KMDGameAssets.BITMAP_FONT_WIN_COUNT_UP,
            fontSize: 40,
            tint: 0xffffff
        }, 720);

        KennethMustDie.skinLogo = new SkinLogo();

        NolimitApplication.addLayerAt(KennethMustDie.sfsOutro.name, KennethMustDie.sfsOutro, 0);
        NolimitApplication.addLayerAt(KennethMustDie.sfsIntro.name, KennethMustDie.sfsIntro, 0);
        NolimitApplication.addLayerAt(KennethMustDie.cfsOutro.name, KennethMustDie.cfsOutro, 0);
        NolimitApplication.addLayerAt(KennethMustDie.cfsIntro.name, KennethMustDie.cfsIntro, 0);
        NolimitApplication.addLayerAt(KennethMustDie.fsOutro.name, KennethMustDie.fsOutro, 0);
        NolimitApplication.addLayerAt(KennethMustDie.fsIntro.name, KennethMustDie.fsIntro, 0);
        NolimitApplication.addLayerAt(KennethMustDie.mgIntro.name, KennethMustDie.mgIntro, 0);
        NolimitApplication.addLayerAt(KennethMustDie.winCapCountUp.name, KennethMustDie.winCapCountUp, 0);
        NolimitApplication.addLayerAt(KennethMustDie.winCap.name, KennethMustDie.winCap, 0);
        NolimitApplication.addLayerAt(KennethMustDie.countUp.name, KennethMustDie.countUp, 0);
        NolimitApplication.addLayerAt(KennethMustDie.bigWin.name, KennethMustDie.bigWin, 0);
        NolimitApplication.addLayerAt(KennethMustDie.winAmount.name, KennethMustDie.winAmount, 0);
        NolimitApplication.addLayerAt(KennethMustDie.additionalFSAward.name, KennethMustDie.additionalFSAward, 0);
        NolimitApplication.addLayerAt(KennethMustDie.blackBg.name, KennethMustDie.blackBg, 0);
        NolimitApplication.addLayerAt(KennethMustDie.miniPayTable.name, KennethMustDie.miniPayTable, 0);
        NolimitApplication.addLayerAt(KennethMustDie.limitCapButton.name, KennethMustDie.limitCapButton, 0);
        NolimitApplication.addLayerAt(KennethMustDie.multipliersChain.name, KennethMustDie.multipliersChain, 0);
        NolimitApplication.addLayerAt(KennethMustDie.winOverlays.name, KennethMustDie.winOverlays, 0);
        NolimitApplication.addLayerAt(KennethMustDie.toggle.name, KennethMustDie.toggle, 0);
        NolimitApplication.addLayerAt(KennethMustDie.xHoleOverlayAnimations.name, KennethMustDie.xHoleOverlayAnimations, 0);
        NolimitApplication.addLayerAt(KennethMustDie.xWaysReveal.name, KennethMustDie.xWaysReveal, 0);
        NolimitApplication.addLayerAt(KennethMustDie.xBet.name, KennethMustDie.xBet, 0);
        if (KennethMustDie.apiPlugin.gameClientConfiguration.boostedBetAllowed) {
            NolimitApplication.addLayerAt(KennethMustDie.xBetReelFrame.name, KennethMustDie.xBetReelFrame, 0);

            // #533
            const betLevel: string = KennethMustDie.apiPlugin.freeBets.hasFreeBets() ? KennethMustDie.apiPlugin.freeBets.getBet() : KennethMustDie.apiPlugin.betLevel.getLevel();
            KennethMustDie.xBetReelFrame.onBetLevelChangeFromKeypad(+betLevel);
        }
        NolimitApplication.addLayerAt(KennethMustDie.specialReelView.name, KennethMustDie.specialReelView, 0);
        NolimitApplication.addLayerAt(KennethMustDie.stickyXH.name, KennethMustDie.stickyXH, 0);
        NolimitApplication.addLayerAt(KennethMustDie.stickyS2.name, KennethMustDie.stickyS2, 0);
        NolimitApplication.addLayerAt(KennethMustDie.stickyXNudges.name, KennethMustDie.stickyXNudges, 0);
        NolimitApplication.addLayerAt(KennethMustDie.stickyWilds.name, KennethMustDie.stickyWilds, 0);
        NolimitApplication.addLayerAt(KennethMustDie.possibleWays.name, KennethMustDie.possibleWays, 0);
        NolimitApplication.addLayerAt(KennethMustDie.nearWinAnticipation.name, KennethMustDie.nearWinAnticipation, 0);
        NolimitApplication.addLayerAt(KennethMustDie.reelView.name, KennethMustDie.reelView, 0);
        NolimitApplication.addLayerAt(KennethMustDie.logo.name, KennethMustDie.logo, 0);
        NolimitApplication.addLayerAt(KennethMustDie.xHoleBlackBg.name, KennethMustDie.xHoleBlackBg, 0);
        NolimitApplication.addLayerAt(KennethMustDie.skinLogo.name, KennethMustDie.skinLogo, 0);
        NolimitApplication.addLayerAt(KennethMustDie.reelFrame.name, KennethMustDie.reelFrame, 0);
        NolimitApplication.addLayerAt(KennethMustDie.car.name, KennethMustDie.car, 0);
        NolimitApplication.addLayerAt(KennethMustDie.backgroundElements.name, KennethMustDie.backgroundElements, 0);

        if (KennethMustDie.model.isRestore) {
            this.handleRestore();
        } else {
            // on game init, setting the symbols with default multi state
            KennethMustDie.specialReelView.reel.stopSymbols.forEach((symbol: SimpleReelModelSymbolData) => {
                const sym: KMDSymbol = (symbol.positionable as KMDSymbol);

                sym.setSplitState(symbol.reelPosition + 1);
            });
        }
    }

    private handleRestore(): void {
        // #330
        KennethMustDie.setKeypadWin(true);

        KennethMustDie.xBet.onRestore();
        KennethMustDie.multipliersChain.onRestore(false);
        KennethMustDie.limitCapButton.onRestore();

        // #420
        if (KennethMustDie.model.isSFSTriggered) {
            KennethMustDie.nearWinAnticipation.playHouseFire();
        }

        const mode: string = KennethMustDie.model.data.mode,
            nextMode: string = KennethMustDie.model.data.nextMode,
            reels: string[][] = KennethMustDie.model.data.reels;

        // sticky wilds, shouldn't be a main game restore.
        if (mode.indexOf("NORMAL") === -1 && nextMode.indexOf("_AVALANCHE") > -1 && nextMode !== KMDGameMode.NORMAL_AVALANCHE) {
            // only middle 3 reels are for sticky wilds
            let xSymbolsCount: number = 0;
            for (let reelId: number = 1; reelId < reels.length - 1; reelId++) {
                xSymbolsCount = 0;
                for (let symId: number = 0; symId < reels[reelId].length; symId++) {
                    if (reels[reelId][symId] === SPECIAL_SYMBOL_NAMES.W) {
                        KennethMustDie.stickyWilds.showStickyWild(reelId, symId, (symId - xSymbolsCount));
                    } else if (reels[reelId][symId] === SPECIAL_SYMBOL_NAMES.X) {
                        xSymbolsCount++;
                    }
                }
            }
        }

        // sticky xNudges
        if (nextMode === KMDGameMode.FREESPIN_COOL || nextMode === KMDGameMode.FREESPIN_SUPER) {
            this.handleStickyXNudgesInRestore(reels);
        }

        // only handling CFS/SFS avalanche cases
        if (nextMode === KMDGameMode.FREESPIN_COOL_AVALANCHE || nextMode === KMDGameMode.FREESPIN_SUPER_AVALANCHE) {
            // sticky S2
            const s2Feature: IFeatureInfo = KennethMustDie.model.s2Feature;
            if (s2Feature.originReelId !== -1) {
                const stopSymbols: SimpleReelModelSymbolData[] = KennethMustDie.reelView.reelModels[s2Feature.originReelId].stopSymbols;
                let s2Symbol: KMDSymbol = (KennethMustDie.reelView.reelModels[s2Feature.originReelId].getStopSymbolAt(0).positionable as KMDSymbol); // this is dummy

                // #535
                for (let i: number = 0; i < stopSymbols.length; i++) {
                    if ((s2Feature.originSymId - 1) === stopSymbols[i].reelPosition) {
                        s2Symbol = (KennethMustDie.reelView.reelModels[s2Feature.originReelId].getStopSymbolAt(i).positionable as KMDSymbol);

                        break;
                    }
                }
                KennethMustDie.stickyS2.showLock(s2Symbol.getY());

                // #407, #380
                s2Symbol.updateTexture(SPECIAL_SYMBOL_NAMES.S2, KennethMustDie.model.data.multiplier[s2Feature.originReelId][s2Feature.originSymId - 1]);
            }

            // sticky xNudges
            this.handleStickyXNudgesInRestore(reels);
        }

        this.handleSymbolsInRestore();
    }

    private handleStickyXNudgesInRestore(reels: string[][]): void {
        // only middle 9 positions are for sticky xNudges
        for (let reelId: number = 1; reelId < reels.length - 1; reelId++) {
            // scan from bottom in middle reels, and xNudge only possible in bottom 2 rows.
            for (let symId: number = reels[reelId].length - 1; symId > 0; symId--) {
                if (reels[reelId][symId] === SPECIAL_SYMBOL_NAMES.NW) {
                    KennethMustDie.stickyXNudges.showStickyXNudge(reelId, symId);

                    break;
                }
            }
        }
    }

    private handleSymbolsInRestore(): void {
        const multiplier: number[][] = KennethMustDie.model.data.multiplier;

        KennethMustDie.reelView.reelModels.forEach((reel: SimpleReelModel, reelId: number) => {
            reel.stopSymbols.forEach((symbol: SimpleReelModelSymbolData) => {
                const multi: number = multiplier[reelId][symbol.reelPosition];

                if (multi > 1) {
                    const sym: KMDSymbol = (symbol.positionable as KMDSymbol);

                    if (["S", "S2", "X_WAYS"].indexOf(sym.name) > -1) {
                        sym.showSymbolCount(((sym.name === SPECIAL_SYMBOL_NAMES.S && KennethMustDie.s1CountReelStop === 3) ? 1 : multi));
                    } else {
                        sym.setSplitState(multi);
                    }
                }
            });
        });

        KennethMustDie.specialReelView.reel.stopSymbols.forEach((symbol: SimpleReelModelSymbolData) => {
            const multi: number = multiplier[symbol.reelPosition + 1][3];

            if (multi > 1) {
                const sym: KMDSymbol = (symbol.positionable as KMDSymbol);

                if (sym.name === SPECIAL_SYMBOL_NAMES.X_WAYS) {
                    sym.showSymbolCount(multi);
                } else {
                    sym.setSplitState(multi);
                    sym.displayLines(multi).totalProgress(1);
                }
            }
        });

        // #534
        if (KennethMustDie.model.xHPos > -1) {
            const stopSymbols: SimpleReelModelSymbolData[] = KennethMustDie.reelView.reelModels[2].stopSymbols;
            let xHSymbol: KMDSymbol = (KennethMustDie.reelView.reelModels[2].getStopSymbolAt(1).positionable as KMDSymbol); // this is dummy

            for (let i: number = 0; i < stopSymbols.length; i++) {
                if (stopSymbols[i].name === SPECIAL_SYMBOL_NAMES.XH) {
                    xHSymbol = (KennethMustDie.reelView.reelModels[2].getStopSymbolAt(i).positionable as KMDSymbol);

                    break;
                }
            }
            xHSymbol.updateAnimation(SPECIAL_SYMBOL_NAMES.XH);
            xHSymbol.setState(KennethMustDie.model.xHPos === 1 ? X_HOLE_ANIMATIONS.ACTIVE : KMD_SYMBOL_ANIMATIONS.NORMAL).timeScale(10);
        }
    }
}